// Editorial visual tokens for the Cyber Insurance Review readout.
// Deliberately local to this feature module: the aesthetic is
// distinct from the SaaS-dashboard pattern used elsewhere.
// Dark-mode variants + CSS-variable migration land in Phase 2b.

export const COLORS = {
  bodyBg: '#FAFAF7',
  panelBg: '#ffffff',
  hairline: '#e8e3d8',
  bodyText: '#0a1f2e',
  mutedText: '#6A7F8D',
  accent: '#8AD0D6',
  retentionBg: '#012438',
  retentionText: '#FAFAF7',
  amber: '#B7791F'
}

export const TYPE = {
  hero: { fontSize: '28px', fontWeight: 500, lineHeight: 1.15, letterSpacing: '-0.01em' },
  sectionHead: { fontSize: '22px', fontWeight: 500, lineHeight: 1.25 },
  lead: { fontSize: '19px', fontWeight: 400, lineHeight: 1.5 },
  body: { fontSize: '16px', fontWeight: 400, lineHeight: 1.6 },
  supporting: { fontSize: '13px', fontWeight: 400, lineHeight: 1.55 },
  smallCaps: {
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '0.18em',
    textTransform: 'uppercase'
  }
}

export const SPACE = {
  sectionGap: '64px',
  sectionMaxWidth: '720px',
  pagePadding: '64px'
}
